import { HEADER_FAIRE_TIMEZONE } from "@faire/web--source/common/consts/HEADER_FAIRE_TIMEZONE";
import { headerInterceptorFactory } from "./headerInterceptor";
export var timezoneHeaderInterceptor = headerInterceptorFactory({
    header: HEADER_FAIRE_TIMEZONE,
    value: function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
});
